//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular from 'angular';
import React from 'react';

import makeAngularReactController from '@react-bridge/angular-react-widget';
import StreamsCreationModal from '@streams/components/StreamsCreationModal';

angular.module('curalate').component('streamsCreationModal', {
  controller: makeAngularReactController(<StreamsCreationModal/>),
});
